(function importStateDefinition() {
    'use strict';
    angular.module('Entities')
        .service('importStateService', [
            'restUrlBuilder', function importStateService(restUrlBuilder) {

                this.getById = function getById(id, detailLevel) {
                    var params = { lod: detailLevel };

                    return restUrlBuilder.one('importStates', id)
                        .get({ params: params });

                };

                this.get = function get(name) {

                    var params = { Name: name };

                    return restUrlBuilder.all('importStates')
                        .get({ params: params });
                };
            }
        ]);
})();